import React from 'react';

const EmergencyCallout = () => {
  return (
    <div className="bg-brand-accent-orange text-white py-2 px-4 text-center text-sm md:text-base fixed top-0 left-0 right-0 z-50">
      <p>
        <span className="font-bold">EMERGENCY SERVICE 24/7:</span> 
        <a href="tel:+17139225702" className="ml-2 underline hover:text-white"> (713) 922-5702</a> 
        {/* Replace with actual emergency number */}
      </p>
    </div>
  );
};

export default EmergencyCallout; 